export const IN_ADDRESS = {
  "CHANDIGARH": [
    {
      "label": "Chandigarh",
      "value": "CHANDIGARH"
    },
    {
      "label": "Not Known",
      "value": "NOT KNOWN"
    }
  ],
  "ANDAMAN AND NICOBAR ISLANDS": [
    { label: "Nicobar", value: "NICOBAR" },
    { label: "North And Middle Andaman", value: "NORTH AND MIDDLE ANDAMAN" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "South Andaman", value: "SOUTH ANDAMAN" }
  ],
  "ANDHRA PRADESH": [
    { label: "Alluri Seetha Rama Raju", value: "ALLURI SEETHA RAMA RAJU" },
    { label: "Amalapuram", value: "AMALAPURAM" },
    { label: "Anakapalli", value: "ANAKAPALLI" },
    { label: "Ananthapuramu", value: "ANANTHAPURAMU" },
    { label: "Annamayya", value: "ANNAMAYYA" },
    { label: "Bapatla", value: "BAPATLA" },
    { label: "Chittoor", value: "CHITTOOR" },
    { label: "East Godavari", value: "EAST GODAVARI" },
    { label: "Eluru", value: "ELURU" },
    { label: "Guntur", value: "GUNTUR" },
    { label: "Kakinada", value: "KAKINADA" },
    { label: "Konaseema", value: "KONASEEMA" },
    { label: "Krishna", value: "KRISHNA" },
    { label: "Kurnool", value: "KURNOOL" },
    { label: "Nandyal", value: "NANDYAL" },
    { label: "Narasaraopet", value: "NARASARAOPET" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "NTR", value: "NTR" },
    { label: "Paderu", value: "PADERU" },
    { label: "Palnadu", value: "PALNADU" },
    { label: "Parvathipuram", value: "PARVATHIPURAM" },
    { label: "Parvathipuram Manyam", value: "PARVATHIPURAM MANYAM" },
    { label: "Prakasam", value: "PRAKASAM" },
    { label: "Puttaparthy", value: "PUTTAPARTHY" },
    { label: "Rayachoti", value: "RAYACHOTI" },
    { label: "SPS Nellore", value: "SPS NELLORE" },
    { label: "Srikakulam", value: "SRIKAKULAM" },
    { label: "Sri Satya Sal", value: "SRI SATYA SAL" },
    { label: "Thirupathi", value: "THIRUPATHI" },
    { label: "Tirupati", value: "TIRUPATI" },
    { label: "Vijayawada", value: "VIJAYAWADA" },
    { label: "Visakhapatnam", value: "VISAKHAPATNAM" },
    { label: "Vizianagaram", value: "VIZIANAGARAM" },
    { label: "West Godavari", value: "WEST GODAVARI" },
    { label: "YSR District Kadapa", value: "YSR DISTRICT KADAPA" }
  ],
  "ARUNACHAL PRADESH": [
    { label: "Anjaw", value: "ANJAW" },
    { label: "Changlang", value: "CHANGLANG" },
    { label: "Dibang Valley", value: "DIBANG VALLEY" },
    { label: "East Kameng", value: "EAST KAMENG" },
    { label: "East Siang", value: "EAST SIANG" },
    { label: "Kamle", value: "KAMLE" },
    { label: "Kra Daadi", value: "KRA DAADI" },
    { label: "Kurung Kumey", value: "KURUNG KUMEY" },
    { label: "Lepa-Rada", value: "LEPA-RADA" },
    { label: "Lohit", value: "LOHIT" },
    { label: "Longding", value: "LONGDING" },
    { label: "Lower Dibang Valley", value: "LOWER DIBANG VALLEY" },
    { label: "Lower Siang", value: "LOWER SIANG" },
    { label: "Lower Subansiri", value: "LOWER SUBANSIRI" },
    { label: "Namsai", value: "NAMSAI" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Pakke Kesang", value: "PAKKE KESANG" },
    { label: "Papum Pare", value: "PAPUM PARE" },
    { label: "Shi-Yomi", value: "SHI-YOMI" },
    { label: "Siang", value: "SIANG" },
    { label: "Tawang", value: "TAWANG" },
    { label: "Tirap", value: "TIRAP" },
    { label: "Upper Siang", value: "UPPER SIANG" },
    { label: "Upper Subansiri", value: "UPPER SUBANSIRI" },
    { label: "West Kameng", value: "WEST KAMENG" },
    { label: "West Siang", value: "WEST SIANG" }
  ],
  "ASSAM": [
    { label: "Baksa", value: "BAKSA" },
    { label: "Barpeta", value: "BARPETA" },
    { label: "Biswanath", value: "BISWANATH" },
    { label: "Bongaigaon", value: "BONGAIGAON" },
    { label: "Cachar", value: "CACHAR" },
    { label: "Charaideo", value: "CHARAIDEO" },
    { label: "Chirang", value: "CHIRANG" },
    { label: "Darrang", value: "DARRANG" },
    { label: "Dhemaji", value: "DHEMAJI" },
    { label: "Dhubri", value: "DHUBRI" },
    { label: "Dibrugarh", value: "DIBRUGARH" },
    { label: "Dima Hasao", value: "DIMA HASAO" },
    { label: "Goalpara", value: "GOALPARA" },
    { label: "Golaghat", value: "GOLAGHAT" },
    { label: "Hailakandi", value: "HAILAKANDI" },
    { label: "Hojai", value: "HOJAI" },
    { label: "Jorhat", value: "JORHAT" },
    { label: "Kamrup Metropolitan", value: "KAMRUP METROPOLITAN" },
    { label: "Kamrup Rural", value: "KAMRUP RURAL" },
    { label: "Karbi Anglong", value: "KARBI ANGLONG" },
    { label: "Karimganj", value: "KARIMGANJ" },
    { label: "Kokrajhar", value: "KOKRAJHAR" },
    { label: "Lakhimpur", value: "LAKHIMPUR" },
    { label: "Majui", value: "MAJUI" },
    { label: "Marigaon", value: "MARIGAON" },
    { label: "Morigaon", value: "MORIGAON" },
    { label: "Nagaon", value: "NAGAON" },
    { label: "Nalbari", value: "NALBARI" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Sivasagar", value: "SIVASAGAR" },
    { label: "Sonitpur", value: "SONITPUR" },
    { label: "South Salmara", value: "SOUTH SALMARA" },
    { label: "Tamulpur", value: "TAMULPUR" },
    { label: "Tinsukia", value: "TINSUKIA" },
    { label: "Udalguri", value: "UDALGURI" },
    { label: "West Karbi Anglong", value: "WEST KARBI ANGLONG" }
  ],
  "BIHAR": [
    { label: "Araria", value: "ARARIA" },
    { label: "Arwal", value: "ARWAL" },
    { label: "Aurangabad", value: "AURANGABAD" },
    { label: "Banka", value: "BANKA" },
    { label: "Begusarai", value: "BEGUSARAI" },
    { label: "Bhagalpur", value: "BHAGALPUR" },
    { label: "Bhojpur", value: "BHOJPUR" },
    { label: "Buxar", value: "BUXAR" },
    { label: "Darbhanga", value: "DARBHANGA" },
    { label: "East Champaran", value: "EAST CHAMPARAN" },
    { label: "Gaya", value: "GAYA" },
    { label: "Gopalganj", value: "GOPALGANJ" },
    { label: "Jamui", value: "JAMUI" },
    { label: "Jehanabad", value: "JEHANABAD" },
    { label: "Kaimur", value: "KAIMUR" },
    { label: "Katihar", value: "KATIHAR" },
    { label: "Khagaria", value: "KHAGARIA" },
    { label: "Kishanganj", value: "KISHANGANJ" },
    { label: "Lakhisarai", value: "LAKHISARAI" },
    { label: "Madhepura", value: "MADHEPURA" },
    { label: "Madhubani", value: "MADHUBANI" },
    { label: "Munger", value: "MUNGER" },
    { label: "Muzaffarpur", value: "MUZAFFARPUR" },
    { label: "Nalanda", value: "NALANDA" },
    { label: "Nawada", value: "NAWADA" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Patna", value: "PATNA" },
    { label: "Purnia", value: "PURNIA" },
    { label: "Rohtas", value: "ROHTAS" },
    { label: "Saharsa", value: "SAHARSA" },
    { label: "Samastipur", value: "SAMASTIPUR" },
    { label: "Saran", value: "SARAN" },
    { label: "Sheikhpura", value: "SHEIKHPURA" },
    { label: "Sheohar", value: "SHEOHAR" },
    { label: "Sitamarhi", value: "SITAMARHI" },
    { label: "Siwan", value: "SIWAN" },
    { label: "Supaul", value: "SUPAUL" },
    { label: "Vaishali", value: "VAISHALI" },
    { label: "West Champaran", value: "WEST CHAMPARAN" }
  ],
  "CHHATTISGARH": [
    { label: "Balod", value: "BALOD" },
    { label: "Balodabazar", value: "BALODABAZAR" },
    { label: "Balrampur", value: "BALRAMPUR" },
    { label: "Bastar", value: "BASTAR" },
    { label: "Bemetara", value: "BEMETARA" },
    { label: "Bijapur", value: "BIJAPUR" },
    { label: "Bilaspur", value: "BILASPUR" },
    { label: "Dantewada", value: "DANTEWADA" },
    { label: "Dhamtari", value: "DHAMTARI" },
    { label: "Durg", value: "DURG" },
    { label: "Gariaband", value: "GARIABAND" },
    { label: "Gaurella Pendra Marwahi", value: "GAURELLA PENDRA MARWAHI" },
    { label: "Janjgir-Champa", value: "JANJGIR-CHAMPA" },
    { label: "Jashpur", value: "JASHPUR" },
    { label: "Kabirdham", value: "KABIRDHAM" },
    { label: "Kanker", value: "KANKER" },
    { label: "Khairagarh-Chhuikhadan-Gandai", value: "KHAIRAGARH-CHHUIKHADAN-GANDAI" },
    { label: "Kondagaon", value: "KONDAGAON" },
    { label: "Korba", value: "KORBA" },
    { label: "Koriya", value: "KORIYA" },
    { label: "Mahasamund", value: "MAHASAMUND" },
    { label: "Manendragarh-Chirmiri-Bharatpur", value: "MANENDRAGARH-CHIRMIRI-BHARATPUR" },
    { label: "Mohla-Manpur-Ambagarh-Chowki", value: "MOHLA-MANPUR-AMBAGARH-CHOWKI" },
    { label: "Mungeli", value: "MUNGELI" },
    { label: "Narayanpur", value: "NARAYANPUR" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Raigarh", value: "RAIGARH" },
    { label: "Raipur", value: "RAIPUR" },
    { label: "Rajnandgaon", value: "RAJNANDGAON" },
    { label: "Sakti", value: "SAKTI" },
    { label: "Sarangarh-Bilaigarh", value: "SARANGARH-BILAIGARH" },
    { label: "Sukma", value: "SUKMA" },
    { label: "Surajpur", value: "SURAJPUR" },
    { label: "Surguja", value: "SURGUJA" }
  ],  
  "DELHI": [
    { label: "Delhi", value: "DELHI" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "New Delhi", value: "NEW DELHI" },
  ],
  "GOA": [
    { label: "North Goa", value: "NORTH GOA" },
    { label: "South Goa", value: "SOUTH GOA" },
    { label: "Not Known", value: "NOT KNOWN" },
  ],
  "GUJARAT": [
    { label: "Ahmedabad", value: "AHMEDABAD" },
    { label: "Amreli", value: "AMRELI" },
    { label: "Anand", value: "ANAND" },
    { label: "Aravali", value: "ARAVALI" },
    { label: "Banaskantha", value: "BANASKANTHA" },
    { label: "Bharuch", value: "BHARUCH" },
    { label: "Bhavnagar", value: "BHAVNAGAR" },
    { label: "Botad", value: "BOTAD" },
    { label: "Chhota Udepur", value: "CHHOTA UDEPUR" },
    { label: "Dahod", value: "DAHOD" },
    { label: "Devbhumi Dwarka", value: "DEVBHUMI DWARKA" },
    { label: "Gandhinagar", value: "GANDHINAGAR" },
    { label: "Gir Somnath", value: "GIR SOMNATH" },
    { label: "Jamnagar", value: "JAMNAGAR" },
    { label: "Junagadh", value: "JUNAGADH" },
    { label: "Kheda", value: "KHEDA" },
    { label: "Kutch", value: "KUTCH" },
    { label: "Mahesana", value: "MAHESANA" },
    { label: "Mahisagar", value: "MAHISAGAR" },
    { label: "Morbi", value: "MORBI" },
    { label: "Narmada", value: "NARMADA" },
    { label: "Navsari", value: "NAVSARI" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Panch Mahals", value: "PANCH MAHALS" },
    { label: "Patan", value: "PATAN" },
    { label: "Porbandar", value: "PORBANDAR" },
    { label: "Rajkot", value: "RAJKOT" },
    { label: "Sabar Kantha", value: "SABAR KANTHA" },
    { label: "Surat", value: "SURAT" },
    { label: "Surendranagar", value: "SURENDRANAGAR" },
    { label: "Tapi", value: "TAPI" },
    { label: "The Dangs", value: "THE DANGS" },
    { label: "Vadodara", value: "VADODARA" },
    { label: "Valsad", value: "VALSAD" }
  ],
  "HARYANA": [
    { label: "Ambala", value: "AMBALA" },
    { label: "Bhiwani", value: "BHIWANI" },
    { label: "Charkhi Dadri", value: "CHARKHI DADRI" },
    { label: "Faridabad", value: "FARIDABAD" },
    { label: "Fatehabad", value: "FATEHABAD" },
    { label: "Gurgaon", value: "GURGAON" },
    { label: "Hisar", value: "HISAR" },
    { label: "Jhajjar", value: "JHAJJAR" },
    { label: "Jind", value: "JIND" },
    { label: "Kaithal", value: "KAITHAL" },
    { label: "Karnal", value: "KARNAL" },
    { label: "Kurukshetra", value: "KURUKSHETRA" },
    { label: "Mahendragarh", value: "MAHENDRAGARH" },
    { label: "Mewat", value: "MEWAT" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Palwal", value: "PALWAL" },
    { label: "Panchkula", value: "PANCHKULA" },
    { label: "Panipat", value: "PANIPAT" },
    { label: "Rewari", value: "REWARI" },
    { label: "Rohtak", value: "ROHTAK" },
    { label: "Sirsa", value: "SIRSA" },
    { label: "Sonipat", value: "SONIPAT" },
    { label: "Yamunanagar", value: "YAMUNANAGAR" }
  ],
  "HIMACHAL PRADESH": [
    { label: "Bilaspur", value: "BILASPUR" },
    { label: "Chamba", value: "CHAMBA" },
    { label: "Hamirpur", value: "HAMIRPUR" },
    { label: "Kangra", value: "KANGRA" },
    { label: "Kinnaur", value: "KINNAUR" },
    { label: "Kullu", value: "KULLU" },
    { label: "Lahaul And Spiti", value: "LAHAUL AND SPITI" },
    { label: "Mandi", value: "MANDI" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Shimla", value: "SHIMLA" },
    { label: "Sirmaur", value: "SIRMAUR" },
    { label: "Solan", value: "SOLAN" },
    { label: "Una", value: "UNA" }
  ],
  "JAMMU AND KASHMIR": [
    { label: "Anantnag", value: "ANANTNAG" },
    { label: "Bandipora", value: "BANDIPORA" },
    { label: "Baramulla", value: "BARAMULLA" },
    { label: "Budgam", value: "BUDGAM" },
    { label: "Doda", value: "DODA" },
    { label: "Ganderbal", value: "GANDERBAL" },
    { label: "Jammu", value: "JAMMU" },
    { label: "Kathua", value: "KATHUA" },
    { label: "Kishtwar", value: "KISHTWAR" },
    { label: "Kulgam", value: "KULGAM" },
    { label: "Kupwada", value: "KUPWADA" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Poonch", value: "POONCH" },
    { label: "Pulwama", value: "PULWAMA" },
    { label: "Rajauri", value: "RAJAURI" },
    { label: "Ramban", value: "RAMBAN" },
    { label: "Reasi", value: "REASI" },
    { label: "Samba", value: "SAMBA" },
    { label: "Shopian", value: "SHOPIAN" },
    { label: "Srinagar", value: "SRINAGAR" },
    { label: "Udhampur", value: "UDHAMPUR" }
  ],
  "JHARKHAND": [
    { label: "Bokaro", value: "BOKARO" },
    { label: "Chatra", value: "CHATRA" },
    { label: "Deoghar", value: "DEOGHAR" },
    { label: "Dhanbad", value: "DHANBAD" },
    { label: "Dumka", value: "DUMKA" },
    { label: "East Singhbhum", value: "EAST SINGHBHUM" },
    { label: "Garhwa", value: "GARHWA" },
    { label: "Giridih", value: "GIRIDIH" },
    { label: "Godda", value: "GODDA" },
    { label: "Gumla", value: "GUMLA" },
    { label: "Hazaribag", value: "HAZARIBAG" },
    { label: "Jamshedpur", value: "JAMSHEDPUR" },
    { label: "Jamtara", value: "JAMTARA" },
    { label: "Khunti", value: "KHUNTI" },
    { label: "Koderma", value: "KODERMA" },
    { label: "Latehar", value: "LATEHAR" },
    { label: "Lohardaga", value: "LOHARDAGA" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Pakur", value: "PAKUR" },
    { label: "Palamu", value: "PALAMU" },
    { label: "Ramgarh", value: "RAMGARH" },
    { label: "Ranchi", value: "RANCHI" },
    { label: "Sahibganj", value: "SAHIBGANJ" },
    { label: "Seraikela", value: "SERAIKELA" },
    { label: "Simdega", value: "SIMDEGA" },
    { label: "West Singhbhum", value: "WEST SINGHBHUM" }
  ],
  "KARNATAKA": [
    { label: "Bagalkot", value: "BAGALKOT" },
    { label: "Bangalore", value: "BANGALORE" },
    { label: "Bangalore Rural", value: "BANGALORE RURAL" },
    { label: "Belgaum", value: "BELGAUM" },
    { label: "Bellary", value: "BELLARY" },
    { label: "Bidar", value: "BIDAR" },
    { label: "Bijapur", value: "BIJAPUR" },
    { label: "Chamrajnagar", value: "CHAMRAJNAGAR" },
    { label: "Chickmagalur", value: "CHICKMAGALUR" },
    { label: "Chikkaballapura", value: "CHIKKABALLAPURA" },
    { label: "Chitradurga", value: "CHITRADURGA" },
    { label: "Dakshina Kannada", value: "DAKSHINA KANNADA" },
    { label: "Davangere", value: "DAVANGERE" },
    { label: "Dharwad", value: "DHARWAD" },
    { label: "Gadag", value: "GADAG" },
    { label: "Gulbarga", value: "GULBARGA" },
    { label: "Hassan", value: "HASSAN" },
    { label: "Haveri", value: "HAVERI" },
    { label: "Kolar", value: "KOLAR" },
    { label: "Koppal", value: "KOPPAL" },
    { label: "Mandya", value: "MANDYA" },
    { label: "Mysore", value: "MYSORE" },
    { label: "North Kannada", value: "NORTH KANNADA" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Raichur", value: "RAICHUR" },
    { label: "Ramanagara", value: "RAMANAGARA" },
    { label: "Shimoga", value: "SHIMOGA" },
    { label: "South Kannada", value: "SOUTH KANNADA" },
    { label: "Tumkur", value: "TUMKUR" },
    { label: "Udupi", value: "UDUPI" },
    { label: "Vijayanagara", value: "VIJAYANAGARA" },
    { label: "Yadgiri", value: "YADGIRI" }
  ],
  "KERALA": [
    { label: "Alappuzha", value: "ALAPPUZHA" },
    { label: "Ernakulam", value: "ERNAKULAM" },
    { label: "Idukki", value: "IDUKKI" },
    { label: "Kannur", value: "KANNUR" },
    { label: "Kasaragod", value: "KASARAGOD" },
    { label: "Kollam", value: "KOLLAM" },
    { label: "Kottayam", value: "KOTTAYAM" },
    { label: "Kozhikode", value: "KOZHIKODE" },
    { label: "Malappuram", value: "MALAPPURAM" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Palakkad", value: "PALAKKAD" },
    { label: "Pathanamthitta", value: "PATHANAMTHITTA" },
    { label: "Thiruvananthapuram", value: "THIRUVANANTHAPURAM" },
    { label: "Thrissur", value: "THRISSUR" },
    { label: "Wayanad", value: "WAYANAD" }
  ],
  "MADHYA PRADESH": [
    { label: "Agar Malwa", value: "AGAR MALWA" },
    { label: "Alirajpur", value: "ALIRAJPUR" },
    { label: "Anuppur", value: "ANUPPUR" },
    { label: "Ashoknagar", value: "ASHOKNAGAR" },
    { label: "Balaghat", value: "BALAGHAT" },
    { label: "Barwani", value: "BARWANI" },
    { label: "Betul", value: "BETUL" },
    { label: "Bhind", value: "BHIND" },
    { label: "Bhopal", value: "BHOPAL" },
    { label: "Burhanpur", value: "BURHANPUR" },
    { label: "Chhatarpur", value: "CHHATARPUR" },
    { label: "Chhindwara", value: "CHHINDWARA" },
    { label: "Damoh", value: "DAMOH" },
    { label: "Datia", value: "DATIA" },
    { label: "Dewas", value: "DEWAS" },
    { label: "Dhar", value: "DHAR" },
    { label: "Dindori", value: "DINDORI" },
    { label: "Guna", value: "GUNA" },
    { label: "Gwalior", value: "GWALIOR" },
    { label: "Harda", value: "HARDA" },
    { label: "Hoshangabad", value: "HOSHANGABAD" },
    { label: "Indore", value: "INDORE" },
    { label: "Jabalpur", value: "JABALPUR" },
    { label: "Jhabua", value: "JHABUA" },
    { label: "Katni", value: "KATNI" },
    { label: "Khandwa", value: "KHANDWA" },
    { label: "Khargone", value: "KHARGONE" },
    { label: "Maihar", value: "MAIHAR" },
    { label: "Mandla", value: "MANDLA" },
    { label: "Mandsaur", value: "MANDSAUR" },
    { label: "Mauganj", value: "MAUGANJ" },
    { label: "Morena", value: "MORENA" },
    { label: "Narsinghpur", value: "NARSINGHPUR" },
    { label: "Neemuch", value: "NEEMUCH" },
    { label: "Niwari", value: "NIWARI" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Pandhurna", value: "PANDHURNA" },
    { label: "Panna", value: "PANNA" },
    { label: "Raisen", value: "RAISEN" },
    { label: "Rajgarh", value: "RAJGARH" },
    { label: "Ratlam", value: "RATLAM" },
    { label: "Rewa", value: "REWA" },
    { label: "Sagar", value: "SAGAR" },
    { label: "Satna", value: "SATNA" },
    { label: "Sehore", value: "SEHORE" },
    { label: "Seoni", value: "SEONI" },
    { label: "Shahdol", value: "SHAHDOL" },
    { label: "Shajapur", value: "SHAJAPUR" },
    { label: "Sheopur", value: "SHEOPUR" },
    { label: "Shivpuri", value: "SHIVPURI" },
    { label: "Sidhi", value: "SIDHI" },
    { label: "Singrauli", value: "SINGRAULI" },
    { label: "Tikamgarh", value: "TIKAMGARH" },
    { label: "Ujjain", value: "UJJAIN" },
    { label: "Umaria", value: "UMARIA" },
    { label: "Vidisha", value: "VIDISHA" }
  ],  
  "MAHARASHTRA": [
    { label: "Ahmednagar", value: "AHMEDNAGAR" },
    { label: "Akola", value: "AKOLA" },
    { label: "Amravati", value: "AMRAVATI" },
    { label: "Aurangabad", value: "AURANGABAD" },
    { label: "Beed", value: "BEED" },
    { label: "Bhandara", value: "BHANDARA" },
    { label: "Buldhana", value: "BULDHANA" },
    { label: "Chandrapur", value: "CHANDRAPUR" },
    { label: "Dhule", value: "DHULE" },
    { label: "Gadchiroli", value: "GADCHIROLI" },
    { label: "Gondia", value: "GONDIA" },
    { label: "Hingoli", value: "HINGOLI" },
    { label: "Jalgaon", value: "JALGAON" },
    { label: "Jalna", value: "JALNA" },
    { label: "Kolhapur", value: "KOLHAPUR" },
    { label: "Latur", value: "LATUR" },
    { label: "Mumbai", value: "MUMBAI" },
    { label: "Nagpur", value: "NAGPUR" },
    { label: "Nanded", value: "NANDED" },
    { label: "Nandurbar", value: "NANDURBAR" },
    { label: "Nashik", value: "NASHIK" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Osmanabad", value: "OSMANABAD" },
    { label: "Palghar", value: "PALGHAR" },
    { label: "Parbhani", value: "PARBHANI" },
    { label: "Pune", value: "PUNE" },
    { label: "Raigarh", value: "RAIGARH" },
    { label: "Ratnagiri", value: "RATNAGIRI" },
    { label: "Sangli", value: "SANGLI" },
    { label: "Satara", value: "SATARA" },
    { label: "Sindhudurg", value: "SINDHUDURG" },
    { label: "Solapur", value: "SOLAPUR" },
    { label: "Thane", value: "THANE" },
    { label: "Wardha", value: "WARDHA" },
    { label: "Washim", value: "WASHIM" },
    { label: "Yavatmal", value: "YAVATMAL" }
  ],
  "MANIPUR": [
    { label: "Bishnupur", value: "BISHNUPUR" },
    { label: "Chandel", value: "CHANDEL" },
    { label: "Churachandpur", value: "CHURACHANDPUR" },
    { label: "Imphal East", value: "IMPHAL EAST" },
    { label: "Imphal West", value: "IMPHAL WEST" },
    { label: "Jiribam", value: "JIRIBAM" },
    { label: "Kakching", value: "KAKCHING" },
    { label: "Kamjong", value: "KAMJONG" },
    { label: "Kangpokpi", value: "KANGPOKPI" },
    { label: "Noney", value: "NONEY" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Pherzawl", value: "PHERZAWL" },
    { label: "Senapati", value: "SENAPATI" },
    { label: "Tamenglong", value: "TAMENGLONG" },
    { label: "Tengnoupal", value: "TENGNOUPAL" },
    { label: "Thoubal", value: "THOUBAL" },
    { label: "Ukhrul", value: "UKHRUL" }
  ],
  "MEGHALAYA": [
    { label: "Eastern West Khasi Hills District", value: "EASTERN WEST KHASI HILLS DISTRICT" },
    { label: "East Garo Hills", value: "EAST GARO HILLS" },
    { label: "East Jaintia Hills", value: "EAST JAINTIA HILLS" },
    { label: "East Khasi Hills", value: "EAST KHASI HILLS" },
    { label: "North Garo Hills", value: "NORTH GARO HILLS" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Ribhoi", value: "RIBHOI" },
    { label: "South Garo Hills", value: "SOUTH GARO HILLS" },
    { label: "South West Garo Hills", value: "SOUTH WEST GARO HILLS" },
    { label: "South West Khasi Hills", value: "SOUTH WEST KHASI HILLS" },
    { label: "West Garo Hills", value: "WEST GARO HILLS" },
    { label: "West Jaintia Hills", value: "WEST JAINTIA HILLS" },
    { label: "West Khasi Hills", value: "WEST KHASI HILLS" }
  ],
  "MIZORAM": [
    { label: "Aizawl", value: "AIZAWL" },
    { label: "Champhai", value: "CHAMPHAI" },
    { label: "Kolasib", value: "KOLASIB" },
    { label: "Lawngtlai", value: "LAWNGTLAI" },
    { label: "Lunglei", value: "LUNGLEI" },
    { label: "Mamit", value: "MAMIT" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Saiha", value: "SAIHA" },
    { label: "Serchhip", value: "SERCHHIP" }
  ], 
  "NAGALAND": [
    { label: "Dimapur", value: "DIMAPUR" },
    { label: "Kiphire", value: "KIPHIRE" },
    { label: "Kohima", value: "KOHIMA" },
    { label: "Longleng", value: "LONGLENG" },
    { label: "Mokokchung", value: "MOKOKCHUNG" },
    { label: "Mon", value: "MON" },
    { label: "Noklak", value: "NOKLAK" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Peren", value: "PEREN" },
    { label: "Phek", value: "PHEK" },
    { label: "Shamator", value: "SHAMATOR" },
    { label: "Tseminyu", value: "TSEMINYU" },
    { label: "Tuensang", value: "TUENSANG" },
    { label: "Wokha", value: "WOKHA" },
    { label: "Zunheboto", value: "ZUNHEBOTO" }
  ],
  "ORISSA": [
    { label: "Angul", value: "ANGUL" },
    { label: "Balasore", value: "BALASORE" },
    { label: "Bargarh", value: "BARGARH" },
    { label: "Bhadrak", value: "BHADRAK" },
    { label: "Bolangir", value: "BOLANGIR" },
    { label: "Boudh", value: "BOUDH" },
    { label: "Cuttack", value: "CUTTACK" },
    { label: "Deogarh", value: "DEOGARH" },
    { label: "Dhenkanal", value: "DHENKANAL" },
    { label: "Gajapati", value: "GAJAPATI" },
    { label: "Ganjam", value: "GANJAM" },
    { label: "Jagatsinghapur", value: "JAGATSINGHAPUR" },
    { label: "Jajapur", value: "JAJAPUR" },
    { label: "Jharsuguda", value: "JHARSUGUDA" },
    { label: "Kalahandi", value: "KALAHANDI" },
    { label: "Kandhamal", value: "KANDHAMAL" },
    { label: "Kendrapara", value: "KENDRAPARA" },
    { label: "Keonjhar", value: "KEONJHAR" },
    { label: "Khordha", value: "KHORDHA" },
    { label: "Koraput", value: "KORAPUT" },
    { label: "Malkangiri", value: "MALKANGIRI" },
    { label: "Mayurbhanj", value: "MAYURBHANJ" },
    { label: "Nabarangapur", value: "NABARANGAPUR" },
    { label: "Nayagarh", value: "NAYAGARH" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Nuapada", value: "NUAPADA" },
    { label: "Puri", value: "PURI" },
    { label: "Rayagada", value: "RAYAGADA" },
    { label: "Sambalpur", value: "SAMBALPUR" },
    { label: "Sonapur", value: "SONAPUR" },
    { label: "Sundergarh", value: "SUNDERGARH" }
  ],
  "PONDICHERRY": [
    { label: "Karaikal", value: "KARAIKAL" },
    { label: "Mahe", value: "MAHE" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Pondicherry", value: "PONDICHERRY" },
    { label: "Yanam", value: "YANAM" }
  ],
  "PUNJAB": [
    { label: "Amritsar", value: "AMRITSAR" },
    { label: "Barnala", value: "BARNALA" },
    { label: "Bathinda", value: "BATHINDA" },
    { label: "Faridkot", value: "FARIDKOT" },
    { label: "Fatehgarh Sahib", value: "FATEHGARH SAHIB" },
    { label: "Fazilka", value: "FAZILKA" },
    { label: "Firozpur", value: "FIROZPUR" },
    { label: "Gurdaspur", value: "GURDASPUR" },
    { label: "Hoshiarpur", value: "HOSHIARPUR" },
    { label: "Jalandhar", value: "JALANDHAR" },
    { label: "Kapurthala", value: "KAPURTHALA" },
    { label: "Ludhiana", value: "LUDHIANA" },
    { label: "Malerkotla", value: "MALERKOTLA" },
    { label: "Mansa", value: "MANSA" },
    { label: "Moga", value: "MOGA" },
    { label: "Muktsar", value: "MUKTSAR" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Pathankot", value: "PATHANKOT" },
    { label: "Patiala", value: "PATIALA" },
    { label: "Rupnagar", value: "RUPNAGAR" },
    { label: "Sangrur", value: "SANGRUR" },
    { label: "Sas Nagar Mohali", value: "SAS NAGAR MOHALI" },
    { label: "Sbs Nagar Nawanshar", value: "SBS NAGAR NAWANSHAR" },
    { label: "Sri Muktsar Sahib", value: "SRI MUKTSAR SAHIB" },
    { label: "Tarantaran", value: "TARANTARAN" }
  ],  
  "RAJASTHAN": [
    { label: "Ajmer", value: "AJMER" },
    { label: "Alwar", value: "ALWAR" },
    { label: "Anupgarh", value: "ANUPGARH" },
    { label: "Balotra", value: "BALOTRA" },
    { label: "Banswara", value: "BANSWARA" },
    { label: "Baran", value: "BARAN" },
    { label: "Barmer", value: "BARMER" },
    { label: "Beawar", value: "BEAWAR" },
    { label: "Bharatpur", value: "BHARATPUR" },
    { label: "Bhilwara", value: "BHILWARA" },
    { label: "Bikaner", value: "BIKANER" },
    { label: "Bundi", value: "BUNDI" },
    { label: "Chittorgarh", value: "CHITTORGARH" },
    { label: "Churu", value: "CHURU" },
    { label: "Dausa", value: "DAUSA" },
    { label: "Deeg", value: "DEEG" },
    { label: "Dholpur", value: "DHOLPUR" },
    { label: "Didwana-Kuchaman", value: "DIDWANA-KUCHAMAN" },
    { label: "Dudu", value: "DUDU" },
    { label: "Dungarpur", value: "DUNGARPUR" },
    { label: "Ganganagar", value: "GANGANAGAR" },
    { label: "Gangapur City", value: "GANGAPUR CITY" },
    { label: "Hanumangarh", value: "HANUMANGARH" },
    { label: "Jaipur", value: "JAIPUR" },
    { label: "Jaipur Rural", value: "JAIPUR RURAL" },
    { label: "Jaisalmer", value: "JAISALMER" },
    { label: "Jalor", value: "JALOR" },
    { label: "Jhalawar", value: "JHALAWAR" },
    { label: "Jhunjhunu", value: "JHUNJHUNU" },
    { label: "Jodhpur", value: "JODHPUR" },
    { label: "Jodhpur Rural", value: "JODHPUR RURAL" },
    { label: "Karauli", value: "KARAULI" },
    { label: "Kekri", value: "KEKRI" },
    { label: "Khairthal-Tijara", value: "KHAIRTHAL-TIJARA" },
    { label: "Kota", value: "KOTA" },
    { label: "Kotputli-Behror", value: "KOTPUTLI-BEHROR" },
    { label: "Nagaur", value: "NAGAUR" },
    { label: "Neemkathana", value: "NEEMKATHANA" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Pali", value: "PALI" },
    { label: "Phalodi", value: "PHALODI" },
    { label: "Pratapgarh", value: "PRATAPGARH" },
    { label: "Rajsamand", value: "RAJSAMAND" },
    { label: "Salumber", value: "SALUMBER" },
    { label: "Sanchore", value: "SANCHORE" },
    { label: "Sawai Madhopur", value: "SAWAI MADHOPUR" },
    { label: "Shahpura", value: "SHAHPURA" },
    { label: "Sikar", value: "SIKAR" },
    { label: "Sirohi", value: "SIROHI" },
    { label: "Tonk", value: "TONK" },
    { label: "Udaipur", value: "UDAIPUR" }
  ],  
  "SIKKIM": [
    { label: "East Sikkim", value: "EAST SIKKIM" },
    { label: "North Sikkim", value: "NORTH SIKKIM" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Pakyong", value: "PAKYONG" },
    { label: "Soreng", value: "SORENG" },
    { label: "South Sikkim", value: "SOUTH SIKKIM" },
    { label: "West Sikkim", value: "WEST SIKKIM" }
  ],
  "TAMIL NADU": [
    { label: "Ariyalur", value: "ARIYALUR" },
    { label: "Chengalpattu", value: "CHENGALPATTU" },
    { label: "Chennai", value: "CHENNAI" },
    { label: "Coimbatore", value: "COIMBATORE" },
    { label: "Cuddalore", value: "CUDDALORE" },
    { label: "Dharmapuri", value: "DHARMAPURI" },
    { label: "Dindigul", value: "DINDIGUL" },
    { label: "Erode", value: "ERODE" },
    { label: "Kallakurichi", value: "KALLAKURICHI" },
    { label: "Kancheepuram", value: "KANCHEEPURAM" },
    { label: "Kanniyakumari", value: "KANNIYAKUMARI" },
    { label: "Karur", value: "KARUR" },
    { label: "Krishnagiri", value: "KRISHNAGIRI" },
    { label: "Madurai", value: "MADURAI" },
    { label: "Myladuthurai", value: "MYLADUTHURAI" },
    { label: "Nagapattinam", value: "NAGAPATTINAM" },
    { label: "Namakkal", value: "NAMAKKAL" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Perambalur", value: "PERAMBALUR" },
    { label: "Pudukkottai", value: "PUDUKKOTTAI" },
    { label: "Ramanathapuram", value: "RAMANATHAPURAM" },
    { label: "Ranipet", value: "RANIPET" },
    { label: "Salem", value: "SALEM" },
    { label: "Sivaganga", value: "SIVAGANGA" },
    { label: "Tenkasi", value: "TENKASI" },
    { label: "Thanjavur", value: "THANJAVUR" },
    { label: "Theni", value: "THENI" },
    { label: "The Nilgiris", value: "THE NILGIRIS" },
    { label: "Thiruvallur", value: "THIRUVALLUR" },
    { label: "Thiruvarur", value: "THIRUVARUR" },
    { label: "Thoothukkudi", value: "THOOTHUKKUDI" },
    { label: "Tiruchirappalli", value: "TIRUCHIRAPPALLI" },
    { label: "Tirunelveli", value: "TIRUNELVELI" },
    { label: "Tirupathur", value: "TIRUPATHUR" },
    { label: "Tiruppur", value: "TIRUPPUR" },
    { label: "Tiruvannamalai", value: "TIRUVANNAMALAI" },
    { label: "Vellore", value: "VELLORE" },
    { label: "Viluppuram", value: "VILUPPURAM" },
    { label: "Virudhunagar", value: "VIRUDHUNAGAR" }
  ],  
  "TRIPURA": [
    { label: "Dhalai", value: "DHALAI" },
    { label: "Gomati", value: "GOMATI" },
    { label: "Khowai", value: "KHOWAI" },
    { label: "North Tripura", value: "NORTH TRIPURA" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Sepahijala", value: "SEPAHIJALA" },
    { label: "South Tripura", value: "SOUTH TRIPURA" },
    { label: "Unakoti", value: "UNAKOTI" },
    { label: "West Tripura", value: "WEST TRIPURA" }
  ],  
  "UTTAR PRADESH": [
    { label: "Agra", value: "AGRA" },
    { label: "Aligarh", value: "ALIGARH" },
    { label: "Allahabad", value: "ALLAHABAD" },
    { label: "Ambedkar Nagar", value: "AMBEDKAR NAGAR" },
    { label: "Amethi", value: "AMETHI" },
    { label: "Auraiya", value: "AURAIYA" },
    { label: "Azamgarh", value: "AZAMGARH" },
    { label: "Badaun", value: "BADAUN" },
    { label: "Baghpat", value: "BAGHPAT" },
    { label: "Bahraich", value: "BAHRAICH" },
    { label: "Ballia", value: "BALLIA" },
    { label: "Balrampur", value: "BALRAMPUR" },
    { label: "Banda", value: "BANDA" },
    { label: "Barabanki", value: "BARABANKI" },
    { label: "Bareilly", value: "BAREILLY" },
    { label: "Basti", value: "BASTI" },
    { label: "Bijnor", value: "BIJNOR" },
    { label: "Bulandshahr", value: "BULANDSHAHR" },
    { label: "Chandauli", value: "CHANDAULI" },
    { label: "Chitrakoot", value: "CHITRAKOOT" },
    { label: "Deoria", value: "DEORIA" },
    { label: "Etah", value: "ETAH" },
    { label: "Etawah", value: "ETAWAH" },
    { label: "Faizabad", value: "FAIZABAD" },
    { label: "Farrukhabad", value: "FARRUKHABAD" },
    { label: "Fatehpur", value: "FATEHPUR" },
    { label: "Firozabad", value: "FIROZABAD" },
    { label: "Gautam Buddha Nagar", value: "GAUTAM BUDDHA NAGAR" },
    { label: "Ghaziabad", value: "GHAZIABAD" },
    { label: "Ghazipur", value: "GHAZIPUR" },
    { label: "Gonda", value: "GONDA" },
    { label: "Gorakhpur", value: "GORAKHPUR" },
    { label: "Hamirpur", value: "HAMIRPUR" },
    { label: "Hardoi", value: "HARDOI" },
    { label: "Jalaun", value: "JALAUN" },
    { label: "Jaunpur", value: "JAUNPUR" },
    { label: "Jhansi", value: "JHANSI" },
    { label: "Jyotiba Phule Nagar", value: "JYOTIBA PHULE NAGAR" },
    { label: "Kannauj", value: "KANNAUJ" },
    { label: "Kanpur", value: "KANPUR" },
    { label: "Kanshiram Nagar", value: "KANSHIRAM NAGAR" },
    { label: "Kaushambi", value: "KAUSHAMBI" },
    { label: "Kushinagar", value: "KUSHINAGAR" },
    { label: "Lakhimpur Kheri", value: "LAKHIMPUR KHERI" },
    { label: "Lalitpur", value: "LALITPUR" },
    { label: "Lucknow", value: "LUCKNOW" },
    { label: "Mahamya Nagar", value: "MAHAMYA NAGAR" },
    { label: "Maharajganj", value: "MAHARAJGANJ" },
    { label: "Mahoba", value: "MAHOBA" },
    { label: "Mainpuri", value: "MAINPURI" },
    { label: "Mathura", value: "MATHURA" },
    { label: "Mau", value: "MAU" },
    { label: "Meerut", value: "MEERUT" },
    { label: "Mirzapur", value: "MIRZAPUR" },
    { label: "Moradabad", value: "MORADABAD" },
    { label: "Muzaffarnagar", value: "MUZAFFARNAGAR" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Panchsheel Nagar", value: "PANCHSHEEL NAGAR" },
    { label: "Pilibhit", value: "PILIBHIT" },
    { label: "Pratapgarh", value: "PRATAPGARH" },
    { label: "Raebareli", value: "RAEBARELI" },
    { label: "Ramabai Nagar", value: "RAMABAI NAGAR" },
    { label: "Rampur", value: "RAMPUR" },
    { label: "Saharanpur", value: "SAHARANPUR" },
    { label: "Sambhal", value: "SAMBHAL" },
    { label: "Sant Kabir Nagar", value: "SANT KABIR NAGAR" },
    { label: "Sant Ravidas Nagar", value: "SANT RAVIDAS NAGAR" },
    { label: "Shahjahanpur", value: "SHAHJAHANPUR" },
    { label: "Shamli", value: "SHAMLI" },
    { label: "Siddharthnagar", value: "SIDDHARTHNAGAR" },
    { label: "Sitapur", value: "SITAPUR" },
    { label: "Sonbhadra", value: "SONBHADRA" },
    { label: "Srawasti", value: "SRAWASTI" },
    { label: "Sultanpur", value: "SULTANPUR" },
    { label: "Unnao", value: "UNNAO" },
    { label: "Varanasi", value: "VARANASI" }
  ],  
  "WEST BENGAL": [
    { label: "Alipurduar", value: "ALIPURDUAR" },
    { label: "Bankura", value: "BANKURA" },
    { label: "Birbhum", value: "BIRBHUM" },
    { label: "Darjiling", value: "DARJILING" },
    { label: "East Burdwan", value: "EAST BURDWAN" },
    { label: "East Midnapore", value: "EAST MIDNAPORE" },
    { label: "Hawrah", value: "HAWRAH" },
    { label: "Hooghly", value: "HOOGHLY" },
    { label: "Jalpaiguri", value: "JALPAIGURI" },
    { label: "Jhargram", value: "JHARGRAM" },
    { label: "Kalimpong", value: "KALIMPONG" },
    { label: "Koch Bihar", value: "KOCH BIHAR" },
    { label: "Kolkata", value: "KOLKATA" },
    { label: "Malda", value: "MALDA" },
    { label: "Murshidabad", value: "MURSHIDABAD" },
    { label: "Nadia", value: "NADIA" },
    { label: "North 24 Parganas", value: "NORTH 24 PARGANAS" },
    { label: "North Dinajpur", value: "NORTH DINAJPUR" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Purbabardhaman", value: "PURBABARDHAMAN" },
    { label: "Puruliya", value: "PURULIYA" },
    { label: "South 24 Parganas", value: "SOUTH 24 PARGANAS" },
    { label: "South Dinajpur", value: "SOUTH DINAJPUR" },
    { label: "Sundarban", value: "SUNDARBAN" },
    { label: "West Burdwan", value: "WEST BURDWAN" },
    { label: "West Midnapore", value: "WEST MIDNAPORE" }
  ],
  "LAKSHADWEEP": [
    { label: "Kavaratti", value: "KAVARATTI" },
    { label: "Not Known", value: "NOT KNOWN" }
  ],
  "TELANGANA": [
    { label: "Adilabad", value: "ADILABAD" },
    { label: "Bhadradri Kothagudem", value: "BHADRADRI KOTHAGUDEM" },
    { label: "Hyderabad", value: "HYDERABAD" },
    { label: "Jagitial", value: "JAGITIAL" },
    { label: "Jayashankar Bhupalapally", value: "JAYASHANKAR BHUPALAPALLY" },
    { label: "Jogulamba Gadwal", value: "JOGULAMBA GADWAL" },
    { label: "Kamareddy", value: "KAMAREDDY" },
    { label: "Karim Nagar", value: "KARIM NAGAR" },
    { label: "Khammam", value: "KHAMMAM" },
    { label: "Kumurambheem Asifabad", value: "KUMURAMBHEEM ASIFABAD" },
    { label: "Mahabubabad", value: "MAHABUBABAD" },
    { label: "Mahbubnagar", value: "MAHBUBNAGAR" },
    { label: "Medak", value: "MEDAK" },
    { label: "Mulugu", value: "MULUGU" },
    { label: "Nagarkurnool", value: "NAGARKURNOOL" },
    { label: "Nalgonda", value: "NALGONDA" },
    { label: "Narayanpet", value: "NARAYANPET" },
    { label: "Nirmal", value: "NIRMAL" },
    { label: "Nizamabad", value: "NIZAMABAD" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Peddapalli", value: "PEDDAPALLI" },
    { label: "Rajanna Sircilla", value: "RAJANNA SIRCILLA" },
    { label: "Rangareddi", value: "RANGAREDDI" },
    { label: "Sangareddy", value: "SANGAREDDY" },
    { label: "Siddipet", value: "SIDDIPET" },
    { label: "Suryapet", value: "SURYAPET" },
    { label: "Vikarabad", value: "VIKARABAD" },
    { label: "Wanaparthy", value: "WANAPARTHY" },
    { label: "Warangal", value: "WARANGAL" }
  ],
  "UTTARAKHAND": [
    { label: "Almora", value: "ALMORA" },
    { label: "Bageshwar", value: "BAGESHWAR" },
    { label: "Chamoli", value: "CHAMOLI" },
    { label: "Champawat", value: "CHAMPAWAT" },
    { label: "Dehradun", value: "DEHRADUN" },
    { label: "Haridwar", value: "HARIDWAR" },
    { label: "Nainital", value: "NAINITAL" },
    { label: "Not Known", value: "NOT KNOWN" },
    { label: "Pauri Garhwal", value: "PAURI GARHWAL" },
    { label: "Pithoragarh", value: "PITHORAGARH" },
    { label: "Rudraprayag", value: "RUDRAPRAYAG" },
    { label: "Tehri Garhwal", value: "TEHRI GARHWAL" },
    { label: "Udham Singh Nagar", value: "UDHAM SINGH NAGAR" },
    { label: "Uttarkashi", value: "UTTARKASHI" }
  ],
 "LADAKH": [
  { label: "Kargil", value: "KARGIL" },
  { label: "Leh", value: "LEH" }
],
"DADRA NAGAR HAVELI AND DAMAN AND DIU": [
  { label: "Daman", value: "DAMAN" },
  { label: "Diu", value: "DIU" },
  { label: "Not Known", value: "NOT KNOWN" },
  { label: "Silvassa", value: "SILVASSA" }
]
}